/**
 * Link to CRM operator guide
 */

import React from 'react'
import { Link } from 'react-router-dom'

export default function CrmHelpLink({ className = '' }) {
  return (
    <Link
      to="/hub/crm/help"
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-green-700 hover:text-green-800 hover:underline focus:outline-none focus:underline ${className}`}
    >
      <svg
        className="size-4 shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <path d="M12 17h.01" />
      </svg>
      Help &amp; guides
    </Link>
  )
}
